import { streaksBarActionTypes } from './Constants';

export function getStreaksInfo(isData) {
	return {
		type: streaksBarActionTypes.GET_STREAKS_INFO,
		payload: { isData },
	};
}

export function getStreaksInfoSuccess(data) {
	return {
		type: streaksBarActionTypes.GET_STREAKS_INFO_SUCCESS,
		payload: { data },
	};
}

export function getStreaksInfoError() {
	return {
		type: streaksBarActionTypes.GET_STREAKS_INFO_ERROR,
	};
}
